var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c(
        "Form",
        {
          ref: "formValidate",
          attrs: { model: _vm.listQuery, "label-width": 80 }
        },
        [
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: "4" } },
                [
                  _c(
                    "FormItem",
                    {
                      staticClass: "mb-10",
                      staticStyle: {},
                      attrs: { label: "渠道搜索" }
                    },
                    [
                      _c("Input", {
                        attrs: { placeholder: "请输入渠道名称" },
                        nativeOn: {
                          keydown: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.preventDefault()
                            return _vm.handleEnter.apply(null, arguments)
                          }
                        },
                        model: {
                          value: _vm.listQuery.name,
                          callback: function($$v) {
                            _vm.$set(_vm.listQuery, "name", $$v)
                          },
                          expression: "listQuery.name"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Col",
                { attrs: { span: "4" } },
                [
                  _c(
                    "FormItem",
                    {
                      staticClass: "mb-10",
                      staticStyle: {},
                      attrs: { label: "所属部门" }
                    },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { placeholder: "请选择所属部门" },
                          model: {
                            value: _vm.listQuery.department_id,
                            callback: function($$v) {
                              _vm.$set(_vm.listQuery, "department_id", $$v)
                            },
                            expression: "listQuery.department_id"
                          }
                        },
                        _vm._l(_vm.departmentList, function(item) {
                          return _c(
                            "Option",
                            { key: item.id, attrs: { value: item.id } },
                            [_vm._v(_vm._s(item.name))]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Col",
                { attrs: { span: "4" } },
                [
                  _c(
                    "FormItem",
                    {
                      staticClass: "mb-10",
                      staticStyle: {},
                      attrs: { label: "状态" }
                    },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { placeholder: "请选择状态" },
                          model: {
                            value: _vm.listQuery.status,
                            callback: function($$v) {
                              _vm.$set(_vm.listQuery, "status", $$v)
                            },
                            expression: "listQuery.status"
                          }
                        },
                        [
                          _c("Option", { attrs: { value: "1" } }, [
                            _vm._v("显示")
                          ]),
                          _vm._v(" "),
                          _c("Option", { attrs: { value: "2" } }, [
                            _vm._v("不显示")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Col",
                { attrs: { span: "4" } },
                [
                  _c(
                    "FormItem",
                    {
                      staticClass: "mb-10",
                      staticStyle: {},
                      attrs: { label: "开放门店" }
                    },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { placeholder: "请选择门店" },
                          model: {
                            value: _vm.listQuery.store_id,
                            callback: function($$v) {
                              _vm.$set(_vm.listQuery, "store_id", $$v)
                            },
                            expression: "listQuery.store_id"
                          }
                        },
                        _vm._l(_vm.storeList, function(item) {
                          return _c(
                            "Option",
                            { key: item.id, attrs: { value: item.id } },
                            [_vm._v(_vm._s(item.name))]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Col",
                { attrs: { span: "8" } },
                [
                  _c(
                    "FormItem",
                    {
                      staticClass: "mb-10",
                      staticStyle: { "margin-left": "10px" },
                      attrs: { "label-width": 0 }
                    },
                    [
                      _c(
                        "Button",
                        {
                          attrs: { type: "primary", icon: "ios-search" },
                          on: { click: _vm.searchList }
                        },
                        [_vm._v("查询")]
                      ),
                      _vm._v(" "),
                      _c(
                        "Button",
                        {
                          attrs: { type: "primary", icon: "ios-search" },
                          on: { click: _vm.emptyFilter }
                        },
                        [_vm._v("清空筛选")]
                      ),
                      _vm._v(" "),
                      _c(
                        "Button",
                        {
                          attrs: { icon: "ios-add", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.addChannel("isAdd")
                            }
                          }
                        },
                        [_vm._v("添加")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "table_wrap" }, [
        _c(
          "div",
          { staticStyle: { width: "100%" } },
          [
            _c("Table", {
              ref: "table",
              attrs: {
                stripe: "",
                border: "",
                height: _vm.tableHeight,
                loading: _vm.tabLoading,
                columns: _vm.tabColumns,
                data: _vm.tabData
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "margin-top": "20px",
                  display: "flex",
                  "justify-content": "flex-end"
                }
              },
              [
                _c("Page", {
                  attrs: {
                    "show-total": "",
                    "show-elevator": "",
                    "show-sizer": "",
                    "page-size-opts": _vm.pageSizeOpts,
                    "page-size": 50,
                    total: _vm.total,
                    current: _vm.listQuery.page,
                    transfer: true
                  },
                  on: {
                    "on-change": _vm.changePage,
                    "on-page-size-change": _vm.changeLimit
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "Modal",
        {
          attrs: {
            closable: false,
            "mask-closable": false,
            "class-name": "vertical-center-modal"
          },
          model: {
            value: _vm.showAddChannel,
            callback: function($$v) {
              _vm.showAddChannel = $$v
            },
            expression: "showAddChannel"
          }
        },
        [
          _c(
            "p",
            {
              staticClass: "modal_title",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("span", [_vm._v(_vm._s(_vm.isTitle))])]
          ),
          _vm._v(" "),
          _c(
            "Form",
            {
              ref: "addChannelForm",
              attrs: {
                model: _vm.addChannelForm,
                rules: _vm.addChannelFormRule,
                "label-width": 80
              }
            },
            [
              _c(
                "FormItem",
                { attrs: { label: "名称", prop: "name" } },
                [
                  _c("Input", {
                    staticStyle: { width: "90%" },
                    attrs: { placeholder: "请输入渠道名称" },
                    model: {
                      value: _vm.addChannelForm.name,
                      callback: function($$v) {
                        _vm.$set(_vm.addChannelForm, "name", $$v)
                      },
                      expression: "addChannelForm.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: "所属部门", prop: "department_id" } },
                [
                  _c(
                    "Select",
                    {
                      staticStyle: { width: "90%" },
                      attrs: { placeholder: "请选择部门" },
                      on: { "on-change": _vm.changeDepartment },
                      model: {
                        value: _vm.addChannelForm.department_id,
                        callback: function($$v) {
                          _vm.$set(_vm.addChannelForm, "department_id", $$v)
                        },
                        expression: "addChannelForm.department_id"
                      }
                    },
                    _vm._l(_vm.departmentList, function(item) {
                      return _c(
                        "Option",
                        { key: item.id, attrs: { value: item.id } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: "状态", prop: "status" } },
                [
                  _c(
                    "RadioGroup",
                    {
                      staticStyle: { width: "90%" },
                      model: {
                        value: _vm.addChannelForm.status,
                        callback: function($$v) {
                          _vm.$set(_vm.addChannelForm, "status", $$v)
                        },
                        expression: "addChannelForm.status"
                      }
                    },
                    [
                      _c("Radio", { attrs: { label: "1" } }, [_vm._v("显示")]),
                      _vm._v(" "),
                      _c("Radio", { attrs: { label: "2" } }, [_vm._v("不显示")])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: "标签", prop: "tag_id" } },
                [
                  _c(
                    "CheckboxGroup",
                    {
                      model: {
                        value: _vm.addChannelForm.tag_id,
                        callback: function($$v) {
                          _vm.$set(_vm.addChannelForm, "tag_id", $$v)
                        },
                        expression: "addChannelForm.tag_id"
                      }
                    },
                    _vm._l(_vm.channelTagList, function(item) {
                      return _c(
                        "Checkbox",
                        { key: item.id, attrs: { label: item.id } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: "开放门店", required: "" } },
                [
                  _c("Input", {
                    staticStyle: { width: "90%" },
                    attrs: { readonly: "", placeholder: "" },
                    model: {
                      value: _vm.openStoreStr,
                      callback: function($$v) {
                        _vm.openStoreStr = $$v
                      },
                      expression: "openStoreStr"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: "备注" } },
                [
                  _c("Input", {
                    staticStyle: { width: "90%" },
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 5 },
                      placeholder: "请输入100字内的备注",
                      maxlength: 100
                    },
                    model: {
                      value: _vm.addChannelForm.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.addChannelForm, "remark", $$v)
                      },
                      expression: "addChannelForm.remark"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                {
                  attrs: { type: "primary", size: "large" },
                  on: {
                    click: function($event) {
                      return _vm.handleSubmit("addChannelForm", _vm.isTitle)
                    }
                  }
                },
                [_vm._v("确定")]
              ),
              _vm._v(" "),
              _c(
                "Button",
                {
                  attrs: { size: "large" },
                  on: {
                    click: function($event) {
                      return _vm.handleReset("addChannelForm")
                    }
                  }
                },
                [_vm._v("取消")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          attrs: {
            closable: false,
            "mask-closable": false,
            "class-name": "vertical-center-modal"
          },
          model: {
            value: _vm.showQrCode,
            callback: function($$v) {
              _vm.showQrCode = $$v
            },
            expression: "showQrCode"
          }
        },
        [
          _c(
            "p",
            {
              staticClass: "modal_title",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("span", [_vm._v("该二维码允许开放的门店")])]
          ),
          _vm._v(" "),
          _c(
            "Form",
            {
              ref: "editQrCodeForm",
              attrs: {
                model: _vm.editQrCodeForm,
                rules: _vm.editQrCodeFormRule,
                "label-width": 80
              }
            },
            [
              _c(
                "FormItem",
                { attrs: { label: "开放门店", prop: "store_id" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "border-bottom": "1px solid #e9e9e9",
                        "padding-bottom": "6px",
                        "margin-bottom": "6px"
                      }
                    },
                    [
                      _c(
                        "Checkbox",
                        {
                          attrs: {
                            indeterminate: _vm.indeterminate,
                            value: _vm.checkAll
                          },
                          nativeOn: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.handleCheckAll.apply(null, arguments)
                            }
                          }
                        },
                        [_vm._v("全选")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "CheckboxGroup",
                    {
                      on: { "on-change": _vm.checkAllGroupChange },
                      model: {
                        value: _vm.editQrCodeForm.store_id,
                        callback: function($$v) {
                          _vm.$set(_vm.editQrCodeForm, "store_id", $$v)
                        },
                        expression: "editQrCodeForm.store_id"
                      }
                    },
                    _vm._l(_vm.qrCodeOpenStoreList, function(item) {
                      return _c(
                        "Checkbox",
                        { key: item.id, attrs: { label: item.id } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                {
                  attrs: { type: "primary", size: "large" },
                  on: { click: _vm.downloadQrCode }
                },
                [_vm._v("保存并下载二维码")]
              ),
              _vm._v(" "),
              _c(
                "Button",
                {
                  attrs: { type: "primary", size: "large" },
                  on: {
                    click: function($event) {
                      return _vm.handleSubmit("editQrCodeForm", _vm.isTitle)
                    }
                  }
                },
                [_vm._v("确定")]
              ),
              _vm._v(" "),
              _c(
                "Button",
                {
                  attrs: { size: "large" },
                  on: {
                    click: function($event) {
                      return _vm.handleReset("editQrCodeForm")
                    }
                  }
                },
                [_vm._v("取消")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-661a2484", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-661a2484","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Crm/CrmSetting/channelManagement.vue
// module id = null
// module chunks = 